module.exports = __webpack_public_path__ + "static/media/v4k.08627489.jpg";